import React, { useEffect } from "react";
import "./TermsCondition.css";

function TermsCondition() {

  useEffect(() => {
    document.title = "Terms & Conditions - Embarque Services";
  }, []);

  return (
  <section className="terms-section">
  <div className="terms-container">

    <h1>Terms and Conditions</h1>

    <p className="terms-intro">
      Welcome to <strong>Embarque Services</strong>. These Terms and
      Conditions apply when you use our website, contact us, book a service,
      or use our home appliance repair and maintenance services. By requesting
      or using our services, you agree to the terms described below.
    </p>


    {/* 1 */}
    <h2>1. Services Provided</h2>

    <p>
      Embarque Services provides independent repair and maintenance services
      for various types of home appliances, which may include washing machines,
      refrigerators, air conditioners, televisions, microwave ovens, water
      purifiers, and other household appliances.
    </p>

    <p>
      Service availability may vary depending on the appliance type, model,
      reported issue, location, technician availability, and availability of
      required spare parts.
    </p>


    {/* 2 */}
    <h2>2. Independent Multi-Brand Service</h2>

    <p>
      We provide independent multi-brand appliance repair and maintenance
      services. Unless specifically stated otherwise, Embarque Services is
      not claiming to be an authorized or official service centre of any
      appliance manufacturer.
    </p>

    <p>
      Any third-party brand names or product names that may appear on our
      website are used only to identify the types of appliances for which
      service may be available.
    </p>


    {/* 3 */}
    <h2>3. Service Appointments</h2>

    <p>
      Customers may request a service appointment through the contact options
      available on our website. Appointment timing is subject to location,
      service requirements, and technician availability.
    </p>

    <p>
      Customers should provide accurate contact details and be available at
      the service location during the agreed appointment period.
    </p>

    <p>
      If you need to cancel or reschedule an appointment, please contact us
      as early as possible.
    </p>


    {/* 4 */}
    <h2>4. Inspection and Diagnosis</h2>

    <p>
      The technician may inspect the appliance to identify the reported issue
      and determine the repair or maintenance work that may be required.
    </p>

    <p>
      An initial assessment may change if additional faults or issues become
      apparent during inspection or repair.
    </p>


    {/* 5 */}
    <h2>5. Spare Parts and Customer Approval</h2>

    <p>
      If inspection indicates that a spare part needs to be repaired or
      replaced, the technician will explain the requirement to the customer
      before carrying out the additional work.
    </p>

    <p>
      Spare part replacement or additional repair work will be carried out
      only after receiving customer approval.
    </p>

    <p>
      Spare part availability may depend on the appliance brand, model, age,
      supplier availability, and market availability.
    </p>


    {/* 6 */}
    <h2>6. Payment</h2>

    <p>
      Customers are responsible for paying the applicable amount for services,
      repairs, and any additional work or spare parts approved by them.
    </p>

    <p>
      Payment is generally due upon completion of the applicable service or
      as otherwise communicated to the customer. Available payment methods
      may include cash or supported online payment methods.
    </p>


    {/* 7 */}
    <h2>7. Customer Responsibilities</h2>

    <p>Customers are responsible for:</p>

    <ul>
      <li>
        Providing accurate contact, address, appliance, and issue details.
      </li>

      <li>
        Providing reasonable and safe access to the appliance at the
        scheduled service location.
      </li>

      <li>
        Informing the technician of known previous repairs, modifications,
        damage, or relevant appliance issues where applicable.
      </li>

      <li>
        Reviewing and approving any additional repair or spare-part
        requirements before such work is carried out.
      </li>

      <li>
        Following reasonable usage or maintenance instructions provided
        following the service.
      </li>
    </ul>


    {/* 8 */}
    <h2>8. Cancellation and Refunds</h2>

    <p>
      Customers may request cancellation or rescheduling before the service
      is carried out by contacting us.
    </p>

    <p>
      If a payment has already been made and a refund is applicable, the
      request may be reviewed based on the service status, work already
      completed, parts supplied or installed, and other relevant
      circumstances.
    </p>

    <p>
      Payments relating to completed services or parts already supplied or
      installed may not be refundable, subject to the circumstances of the
      service.
    </p>


    {/* 9 */}
    <h2>9. Service Outcomes</h2>

    <p>
      We aim to provide appropriate repair and maintenance services based on
      the condition of the appliance and the issue identified during
      inspection.
    </p>

    <p>
      However, repair outcomes can depend on factors including appliance age,
      existing condition, previous repairs, availability of compatible parts,
      and faults that may not be apparent during the initial inspection.
    </p>


    {/* 10 */}
    <h2>10. Pre-Existing Issues</h2>

    <p>
      Embarque Services is not responsible for faults, physical damage,
      electrical issues, previous repair work, improper installation,
      unauthorized modifications, normal wear and tear, or other conditions
      that existed before our service visit.
    </p>

    <p>
      Where a pre-existing condition affects the requested repair, the
      technician may explain the issue and available service options to the
      customer.
    </p>


    {/* 11 */}
    <h2>11. Limitation of Liability</h2>

    <p>
      To the extent permitted by applicable law, Embarque Services will not
      be responsible for indirect or consequential losses arising from
      circumstances outside our reasonable control.
    </p>

    <p>
      Nothing in these Terms and Conditions is intended to exclude or limit
      rights or liabilities that cannot legally be excluded under applicable
      law.
    </p>


    {/* 12 */}
    <h2>12. Privacy and Customer Information</h2>

    <p>
      Information provided by customers may be used to process service
      requests, communicate regarding appointments, provide customer support,
      maintain relevant service records, and operate our business.
    </p>

    <p>
      For more information about how personal information is handled,
      please refer to our Privacy Policy.
    </p>


    {/* 13 */}
    <h2>13. Website Information</h2>

    <p>
      We make reasonable efforts to keep information on our website accurate
      and current. However, service availability, service areas, operating
      hours, and other information may change from time to time.
    </p>


    {/* 14 */}
    <h2>14. Changes to These Terms</h2>

    <p>
      We may update these Terms and Conditions when our services, business
      practices, or applicable requirements change. Updated terms will be
      published on this page with the applicable effective date where
      appropriate.
    </p>


    {/* 15 */}
    <h2>15. Contact Us</h2>

    <p>
      If you have questions about these Terms and Conditions or need
      assistance regarding a service request, please contact:
    </p>

    <div className="terms-contact-info">

      <p>
        <strong>Embarque Services</strong>
      </p>

      <p>
        <strong>Address:</strong>
        <br />
        90/48, Heera Nagar Thoppucolony,
        <br />
        Madurai,
        <br />
        Madurai South,
        <br />
        Tamil Nadu - 625001
      </p>

      <p>
        <strong>Email:</strong>{" "}
        <a href="mailto:embarque.ads@gmail.com">
          embarque.ads@gmail.com
        </a>
      </p>

      <p>
        <strong>Phone:</strong>{" "}
        <a href="tel:+919363929984">
          +91 93639 29984
        </a>
      </p>

    </div>

  </div>
</section>




  );
}

export default TermsCondition;